import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { DropDownItem } from '../../../models/DropDownItem';
import { getEvdaDepartmentsRegionFilterState } from '../../../redux/selectors/filterSelector';
import { FilterAction } from '../../../redux/states/filterState';
import {MapPoint} from '../../../service/MapPoint';
import CustomDropDownList, { FilterType } from './customDropDownList';

  const options: DropDownItem[] = [
    {Element:{ key: '01', name: 'Ain'}, selected: false, hidden: false },
    {Element:{key: '02', name: 'Aisne'}, selected: false, hidden: false },
    {Element:{key: '03', name: 'Allier'}, selected: false, hidden: false },
    {Element:{ key:'04', name: 'Alpes-de-Haute-Provence'}, selected: false, hidden: false },
    {Element:{key: '05', name: 'Hautes-Alpes'}, selected: false, hidden: false },
    {Element:{key: '06', name: 'Alpes-Maritimes'}, selected: false, hidden: false },
    {Element:{key: '07', name: 'Ardèche'}, selected: false, hidden: false },
    {Element:{key: '08', name: 'Ardennes'}, selected: false, hidden: false },
    {Element:{key: '09', name: 'Ariège'}, selected: false, hidden: false },
    {Element:{key: '10', name: 'Aube'}, selected: false, hidden: false },
    {Element:{key: '11', name: 'Aude'}, selected: false, hidden: false },
    {Element:{key: '12', name: 'Aveyron'}, selected: false, hidden: false },
    {Element:{key: '13', name: 'Bouches-du-Rhône'}, selected: false, hidden: false },
    {Element:{key: '14', name: 'Calvados'}, selected: false, hidden: false },
    {Element:{key: '15', name: 'Cantal'}, selected: false, hidden: false },
    {Element:{key: '16', name: 'Charente'}, selected: false, hidden: false },
    {Element:{key: '17', name: 'Charente-Maritime'}, selected: false, hidden: false },
    {Element:{key: '18', name: 'Cher'}, selected: false, hidden: false },
    {Element:{key: '19', name: 'Corrèze'}, selected: false, hidden: false },
    {Element:{key: '2A', name: 'Corse-du-Sud'}, selected: false, hidden: false },
    {Element:{key: '2B', name: 'Haute-Corse'}, selected: false, hidden: false },
    {Element:{key: '21', name: 'Côte-d\'Or'}, selected: false, hidden: false },
    {Element:{key:'22', name: 'Côtes-d\'Armor'}, selected: false, hidden: false },
    {Element:{key: '23', name: 'Creuse'}, selected: false, hidden: false },
    {Element:{key: '24', name: 'Dordogne'}, selected: false, hidden: false },
    {Element:{key: '25', name: 'Doubs'}, selected: false, hidden: false },
    {Element:{key: '26', name: 'Drôme'}, selected: false, hidden: false },
    {Element:{key: '27', name: 'Eure'}, selected: false, hidden: false },
    {Element:{key: '28', name: 'Eure-et-Loir'}, selected: false, hidden: false },
    {Element:{key: '29', name: 'Finistère'}, selected: false, hidden: false },
    {Element:{ key:'30', name: 'Gard'}, selected: false, hidden: false },
    {Element:{ key:'31', name: 'Haute-Garonne'}, selected: false, hidden: false },
    {Element:{ key:'32', name: 'Gers'}, selected: false, hidden: false },
    {Element:{ key:'33', name: 'Gironde'}, selected: false, hidden: false },
    {Element:{ key:'34', name: 'Hérault'}, selected: false, hidden: false },
    {Element:{ key:'35', name: 'Ille-et-Vilaine'}, selected: false, hidden: false },
    {Element:{ key:'36', name: 'Indre'}, selected: false, hidden: false },
    {Element:{ key:'37', name: 'Indre-et-Loire'}, selected: false, hidden: false },
    {Element:{ key:'38', name: 'Isère'}, selected: false, hidden: false },
    {Element:{ key:'39', name: 'Jura'}, selected: false, hidden: false },
    {Element:{ key:'40', name: 'Landes'}, selected: false, hidden: false },
    {Element:{ key:'41', name: 'Loir-et-Cher'}, selected: false, hidden: false },
    {Element:{ key:'42', name: 'Loire'}, selected: false, hidden: false },
    {Element:{ key:'43', name: 'Haute-Loire'}, selected: false, hidden: false },
    {Element:{ key:'44', name: 'Loire-Atlantique'}, selected: false, hidden: false },
    {Element:{ key:'45', name: 'Loiret'}, selected: false, hidden: false },
    {Element:{ key:'46', name: 'Lot'}, selected: false, hidden: false },
    {Element:{ key:'47', name: 'Lot-et-Garonne'}, selected: false, hidden: false },
    {Element:{ key:'48', name: 'Lozère'}, selected: false, hidden: false },
    {Element:{ key:'49', name: 'Maine-et-Loire'}, selected: false, hidden: false },
    {Element:{key:'50', name: 'Manche'}, selected: false, hidden: false },
    {Element:{ key:'51', name: 'Marne'}, selected: false, hidden: false },
    {Element:{key: '52', name: 'Haute-Marne'}, selected: false, hidden: false },
    {Element:{ key:'53', name: 'Mayenne'}, selected: false, hidden: false },
    {Element:{key: '54', name: 'Meurthe-et-Moselle'}, selected: false, hidden: false },
    {Element:{key:'55', name: 'Meuse'}, selected: false, hidden: false },
    {Element:{ key:'56', name: 'Morbihan'}, selected: false, hidden: false },
    {Element:{key: '57', name: 'Moselle'}, selected: false, hidden: false },
    {Element:{key: '58', name: 'Nièvre'}, selected: false, hidden: false },
    {Element:{key: '59', name: 'Nord'}, selected: false, hidden: false },
    {Element:{ key:'60', name: 'Oise'}, selected: false, hidden: false },
    {Element:{ key:'61', name: 'Orne'}, selected: false, hidden: false },
    {Element:{ key:'62', name: 'Pas-de-Calais'}, selected: false, hidden: false },
    {Element:{ key:'63', name: 'Puy-de-Dôme'}, selected: false, hidden: false },
    {Element:{ key:'64', name: 'Pyrénées-Atlantiques'}, selected: false, hidden: false },
    {Element:{key: '65', name: 'Hautes-Pyrénées'}, selected: false, hidden: false },
    {Element:{key: '66', name: 'Pyrénées-Orientales'}, selected: false, hidden: false },
    {Element:{key: '67', name: 'Bas-Rhin'}, selected: false, hidden: false },
    {Element:{key: '68', name: 'Haut-Rhin'}, selected: false, hidden: false },
    {Element:{key: '69', name: 'Rhône'}, selected: false, hidden: false },
    {Element:{key: '70', name: 'Haute-Saône'}, selected: false, hidden: false },
    {Element:{key: '71', name: 'Saône-et-Loire'}, selected: false, hidden: false },
    {Element:{key: '72', name: 'Sarthe'}, selected: false, hidden: false },
    {Element:{key: '73', name: 'Savoie'}, selected: false, hidden: false },
    {Element:{key: '74', name: 'Haute-Savoie'}, selected: false, hidden: false },
    {Element:{key: '75', name: 'Paris'}, selected: false, hidden: false },
    {Element:{key: '76', name: 'Seine-Maritime'}, selected: false, hidden: false },
    {Element:{key: '77', name: 'Seine-et-Marne'}, selected: false, hidden: false },
    {Element:{key: '78', name: 'Yvelines'}, selected: false, hidden: false },
    {Element:{key: '79', name: 'Deux-Sèvres'}, selected: false, hidden: false },
    {Element:{key: '80', name: 'Somme'}, selected: false, hidden: false },
    {Element:{key: '81', name: 'Tarn'}, selected: false, hidden: false },
    {Element:{key: '82', name: 'Tarn-et-Garonne'}, selected: false, hidden: false },
    {Element:{key: '83', name: 'Var'}, selected: false, hidden: false },
    {Element:{key: '84', name: 'Vaucluse'}, selected: false, hidden: false },
    {Element:{key: '85', name: 'Vendée'}, selected: false, hidden: false },
    {Element:{key: '86', name: 'Vienne'}, selected: false, hidden: false },
    {Element:{ key:'87', name: 'Haute-Vienne'}, selected: false, hidden: false },
    {Element:{key: '88', name: 'Vosges'}, selected: false, hidden: false },
    {Element:{key: '89', name: 'Yonne'}, selected: false, hidden: false },
    {Element:{key: '90', name: 'Territoire de Belfort'}, selected: false, hidden: false },
    {Element:{key: '91', name: 'Essonne'}, selected: false, hidden: false },
    {Element:{key: '92', name: 'Hauts-de-Seine'}, selected: false, hidden: false },
    {Element:{key: '93', name: 'Seine-Saint-Denis'}, selected: false, hidden: false },
    {Element:{key: '94', name: 'Val-de-Marne'}, selected: false, hidden: false },
    {Element:{key: '95', name: 'Val-d\'Oise'}, selected: false, hidden: false },
    {Element:{key: '971', name: 'Guadeloupe'}, selected: false, hidden: false },
    {Element:{key: '972', name: 'Martinique'}, selected: false, hidden: false },
    {Element:{key: '973', name: 'Guyane'}, selected: false, hidden: false },
    {Element:{key: '974', name: 'La Réunion'}, selected: false, hidden: false },
    {Element:{key: '976', name: 'Mayotte'}, selected: false, hidden: false },
    
  ];
export type Props = {
  data: MapPoint[]
}

const DepartmentsSelectionComponent:React.FC<Props>=({data})=>{
  const dispatch = useDispatch()
  const departmentsFilter =useSelector(getEvdaDepartmentsRegionFilterState)
  const [items,setItems]=useState<DropDownItem[]>(options)
  const { t } = useTranslation();
  useEffect(()=>{
    setItems(current =>
      current.map(obj => {
        const objData = data.find(dept => dept.node === obj.Element.key);
        // Lorsque la donnée actuelle correspondant à ce pays est indisponible, on n'affiche pas ce pays dans la liste
        // et on le désélectionne.
        if (!objData || objData?.esperance_de_vie === 'nd' || objData?.esperance_de_vie === 'NaN') {
          return {...obj, selected:false, hidden: true};
        }
        else if (departmentsFilter.selectedRegions.filter(region=>region.Element.key===obj.Element.key).length>0) {
          return {...obj, selected:true, hidden: false};
        }
        else{
          return {...obj, selected:false, hidden: false};
        }
      }),
    );
  },[departmentsFilter.selectedRegions, data])

    const onSetRegionsSelection=(selection:DropDownItem)=>{
      dispatch(FilterAction.setEvdaDepartmentsRegionSelection(selection))
  }
    return (<div className='filter-type-container'>
        <label>{t("filter_label_departments")}</label>
        <div>
        <CustomDropDownList enableTranslate={true} filterType={FilterType.Department} emptyField={t('no_department_selected')} items={items}  onSetSelection={onSetRegionsSelection} ></CustomDropDownList>
        </div>
    </div>)
}

export default  DepartmentsSelectionComponent